import YourDealerSummary from './YourDealerSummary';

export default YourDealerSummary;
